import { useState, useEffect } from "react";
import type { SponsorAdPublic } from "@dugads/shared";
import * as api from "@/lib/api";
import { SponsorAdCarousel } from "./sponsor-ad-carousel";

// Persistent sponsor banner shown at the top of the shell for parents and
// unaffiliated spectators. Lives in the layout so it survives route changes.
export function SpectatorSponsorBanner() {
  const [ads, setAds] = useState<SponsorAdPublic[]>([]);

  useEffect(() => {
    api.getMySponsorAds().then((res) => setAds(res.ads)).catch(() => {});
  }, []);

  if (ads.length === 0) return null;

  return (
    <div className="border-b border-border bg-muted/30 px-4 py-2 md:px-6" data-region="spectator-sponsor-banner">
      <SponsorAdCarousel ads={ads} />
    </div>
  );
}
